import { render, staticRenderFns } from "./CardRemainingEvidenceSubmission.vue?vue&type=template&id=0c9f79e9&scoped=true&"
import script from "./CardRemainingEvidenceSubmission.vue?vue&type=script&lang=js&"
export * from "./CardRemainingEvidenceSubmission.vue?vue&type=script&lang=js&"
import style0 from "./CardRemainingEvidenceSubmission.vue?vue&type=style&index=0&id=0c9f79e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f79e9",
  null
  
)

export default component.exports